
<script setup>

  import { ref, watch, onMounted } from 'vue';

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { seenPlayerDialog } from '../stores/activity-1.js';

  import topImage from '../images/activity-1-intro-top.jpg';

  import bottomImage from '../images/activity-1-intro-bottom.jpg';

  const ready = ref( false );

  onMounted( () => {

    watch( seenPlayerDialog, () => {

      if ( seenPlayerDialog.value ) setTimeout( () => ready.value = true, 100 );

    }, { immediate: true } );

  } );

</script>

<template>

  <article>
    
    <div class="grid md:grid-rows-2 md:grid-cols-3 min-h-view">

      <div :class="[ 'self-center justify-self-center md:row-span-2 md:col-span-2 p-6 md:p-12 lg:p-24 transition-[opacity,transform] duration-1000',
      
        { 'opacity-0 -translate-x-full': ! ready } ]">

        <div class="max-w-xl">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 1</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Hearing All the Stories</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            We can't truly know history until we have heard <strong><em>all</em></strong> the stories.

          </p>

          <p class="mt-4 leading-7 text-neutral-700">

            For every history-shaping event, there are multiple perspectives.

            Every person touched by the event has a different experience.

            And for every event we study, it's our responsibility to seek out as many perspectives as possible.
            
            If you want to change an opinion, you must understand the perspective that contributed to the belief.

          </p>

          <h3 class="mt-8 text-2xl md:text-3xl font-medium font-serif italic">About This Activity</h3>

          <p class="mt-4 leading-7 text-neutral-700">

            In this activity, we'll show you four historic photographs.

            Examine each one carefully and discuss what perspectives may be represented.

          </p>

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 mt-12 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/1/photo/1">

            <span>Continue</span>

            <ArrowRightCircleIcon class="w-8" />

          </RouterLink>

        </div>

      </div>

      <figure aria-label="A group of churchgoers gathered in a wooded area of Lewis Mountain."
      
        :class="[ 'hidden md:block bg-cover bg-center transition-[opacity,transform] duration-700', { 'opacity-0 translate-x-full': ! ready } ]"
      
        :style="{ 'background-image': `url( ${ topImage } )` }" />

      <figure aria-label="Historic, wooden signage at Lewis Mountain entrance that reads: Lewis Mountain Negro Area, Coffee Shop and Cottages, Campground, Picnic Ground, Entrance."
      
        :class="[ 'hidden md:block bg-cover bg-center transition-[opacity,transform] duration-1000', { 'opacity-0 translate-x-full': ! ready } ]"
        
        :style="{ 'background-image': `url( ${ bottomImage } )` }" />

    </div>

  </article>

</template>
